export default (state = {}, action) => {
  switch(action.type) {
    case 'ADMIN_ARTIST_CLICK':
      return {
        ...state,
        currentArtist: action.payload.currentArtist
      };
    case 'ADMIN_NEW_CANCEL':
      return {
        ...state,
        showNew: 'none',
      };
    default:
      return state;
  }
  return state;
}



// WEBPACK FOOTER //
// ./src/reducers/admin.js